module.exports = __webpack_public_path__ + "img/no.8bbaf04f.jpg";